module.exports = __webpack_public_path__ + "img/charactors1.bbca7aa9.png";